import {
  AngleTool,
  AnnotationTool,
  ArrowAnnotateTool,
  BidirectionalTool,
  CircleROITool,
  CobbAngleTool,
  CrosshairsTool,
  EllipticalROITool,
  LengthTool,
  MagnifyTool,
  PanTool,
  PlanarFreehandROITool,
  PlanarRotateTool,
  ProbeTool,
  RectangleROITool,
  ReferenceLinesTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from '@cornerstonejs/tools';
import Zoom from '../components/SVGComponents/Zoom';
import Viewer from '../pages/StudyViewer/Viewer';
import { isMobile } from 'react-device-detect';
import { getEnv,getEnvList } from '../helpers/EnvHelper';
import { resolveBackendForHost } from '../helpers/DomainConfigHelper';
export { resolveBackendForHost } from '../helpers/DomainConfigHelper';

export const AuthRoutes = {
  PATHOLOGY: '/pathology/list',
  EDITADMINUSER: '/user/edit',
  VIEWADMINUSER: '/user/view',
  ERRORCODE: '/errorList/list',
  MODALITY: '/modality/list',
  SUBMODALITY: '/sub-modality/list',
  ANNOTATION: '/annotation/list',
  ADDANNOTATION: '/master/add-annotation',
  VIEWANNOTATION: '/annotation/view',
  ERRORSTUDY: '/errorList/error',
  AUDITLOG: '/audit/logs',
  ISSUESANDTROUBLESHOOTING: '/issues-and-troubleshooting/setting',
  FIRMLIST: '/firm/list',
  PROJECTLIST: '/project/list',
  CLIENTLIST: '/client/list',
  FIRMDETAILS: '/firm/view-firm',
  PROJECTDETAILS: '/project/view-project',
  USERVIEW: '/user/view',
  ADDHOSPITAL: '/firm/add-hospital-client',
  ADDPROJECT: '/project/add-hospital-client',
  ADDTELERADIOLOGYCENTRE: '/firm/add-trc',
  ADDIMAGINGCENTRE: '/firm/add-ic',
  EDITHOSPITAL: '/firm/edit',
  EDITPROJECT: '/project/edit',
  PROVIDERLIST: '/provider/list',
  PROVIDERVIEW: '/provider/view',

  SUPERVISORLIST: '/user/list-supervisor',
  //ADDSUPERVISOR: "/user/add-supervisor",
  MYADDSUPERVISOR: '/user/add-supervisor',
  FIRMDOCTORLIST: '/user/list-doctor',
  //ADDFIRMDOCTOR: "/user/add-doctor",
  MYADDFIRMDOCTOR: '/user/add-doctor',
  FIRMTECHNICIANLIST: '/user/list-user',
  //ADDFIRMTECHNICIAN: "/user/add-user",
  MYADDFIRMTECHNICIAN: '/user/add-user',
  ADMINRADIOLOGISTLIST: '/user/list-radiologist',
  RADIOLOGISTLIST: '/provider/list',
  //ADDRADIOLOGIST: "/user/add-radiologist",
  MYADDRADIOLOGIST: '/user/add-radiologist',
  ADMINUSERLIST: '/user/list-admin',
  //ADDADMINUSER: "/user/add-admin",
  MYADDADMINUSER: '/user/add-admin',
  FIRMADMINUSERLIST: '/user/list-firm-admin',
  //ADDFIRMADMINUSER: "/user/add-firm-admin",
  MYADDFIRMADMINUSER: '/user/add-firm-admin',
  //EDITUSER: "/user/edit",
  MYEDITUSER: '/user/edit',
  //VIEWUSER: "/user/view",
  MYVIEWUSER: '/user/view',
  HEADERTEMPLATE: '/firm/list/header/template',
  EDITHEADERTEMPLATE: '/firm/edit/header-template',
  CHANGEPWD: '/user/change-pwd',
  FORCECHANGEPWD: '/user/force-change-pwd',
  UPLOADSTUDY: '/upload/study',
  STUDYLIST: '/new/studylist',
  STUDYVIEWER: '/new/study/load/:studyId',
  BLITZREPORTING: '/new/blitz/reporting',
  NONXRAYADVANCEVIEWER: '/new/study/load/nonXrayAdvanceViewer/:studyId',
  PRIORSTUDYVIEWER: '/new/study/priors/load/:studyId',
  // STUDYVIEWER: "/study/load/:studyId",
  // PRIORSTUDYVIEWER: "/study/priors/load/:studyId",
  REPORT: 'patient/load/',
  EXPORTSTUDY: 'export/study',
  REPORTTEMPLATES: '/report/list/template/:tabId',
  ADDREPORTTEMPLATE: '/report/add/template/:tabId',
  EDITREPORTTEMPLATE: '/report/edit/template/:tabId',
  ACCOUNTANDSETTINGS: '/user/account-and-settings',
  ANALYTICS: '/analytics',
  SHOW_SHARED_REPORT: '/shared/report/view',
  ABOUT: '/about',
  BILLING: '/billing/detailed/sheet',
  BILLING_DATA_DOWNLOAD_FORM : '/new/billing/download-sheet-form',
  PING: '/ping',
  PRIVACY_POLICY: '/privacy-policy',
  SHAREDVIEWER: '/shared/study',
  MOBILEMORE: '/options',
  NOT_ALLOWED: '/not-allowed',
  REPORT_TEMPLATE: '/report/list/template/1',
  AGENTIC_TEMPLATE: '/agentic/list/template/1',
  ADD_AGENTIC_TEMPLATE: '/agentic/add/template',
  EDIT_AGENTIC_TEMPLATE: '/agentic/edit/:agentId',
  AI_NODE_CONFIG: '/ai/node/list',
  EXTERNAL_FIRM_CONFIG: '/external/firm/list',
  RETURN_REASON_CATEGORY_MANAGEMENT: '/return/reason/category/list',
  MY_STYLES:'/my-style/1',
  ADD_STYLE: '/styles/add/template/1',
  EDIT_STYLE: '/styles/edit/:styleId',
  TYPISTUSERLIST: "/user/list-typist",
  ADDTYPIST: "/user/add-typist",
  PACSQUEUELIST: "/pacs/queue/list",
  AIREQUESTLIST: '/ai/request/list',
  GATEWAY_DASHBOARD: '/gateway/dashboard',
  FIRM2FIRM_DASHBOARD: '/firm2firm/dashboard/list',
  DOWNLOADTRIGGER: '/download/trigger',
  HANGINGPROTOCOLLIST: '/hangingprotocol/list',
  // V2 authoring screens (MedDream hangingProtocolsV2 format). Runs alongside the
  // v1 pages above rather than replacing them. A group holds ordered protocols,
  // so each level gets its own wizard.
  HANGINGPROTOCOLV2: '/hangingprotocolv2',
  HPV2_ADDGROUP: '/hangingprotocolv2/group/add',
  HPV2_EDITGROUP: '/hangingprotocolv2/group/edit',
  HPV2_VIEWGROUP: '/hangingprotocolv2/group/view',
  HPV2_ADDPROTOCOL: '/hangingprotocolv2/protocol/add',
  HPV2_EDITPROTOCOL: '/hangingprotocolv2/protocol/edit',
  HPV2_VIEWPROTOCOL: '/hangingprotocolv2/protocol/view',
  ADDHANGINGPROTOCOL: '/hangingprotocol/add',
  EDITHANGINGPROTOCOL: '/hangingprotocol/edit',
  VIEWHANGINGPROTOCOL: '/hangingprotocol/view',
  ADVLICENSE:"/adv/license/list",
  AIDRAFTMODELSTATS: "/ai-draft/model-stats",
  REFRESHAGENTLIST: '/refresh/agentlist',
  REPORTINGWIDGET: '/reporting-widget',
  USER_DATA_DUMP: '/internal/datadump/*',
  DOWNLOADAGENTICEVENT: '/download/agenticevent',
};

export const NonAuthRoutes = {
  ROOT: '/',
  LOGIN: '/login',
  VIEWPDF: '/study/report/view/pdf/:studyId/:firmId',
  FORGOTPASSWORD: '/forgot-pwd',
  ENTEROTP: '/authenticate-otp',
  RESETPASSWORD: '/reset-pwd',
  CONTEXTSWITCHSTUDYLIST: '/open-api/loadStudyList',
  CONTEXTSWITCHSTUDYVIEWER: '/open-api/loadStudyViewer',
  TWOFACTORAUTHENTICATION: '/twofa-otp',
  GIZMOWIDGET: '/gizmo-widget',
  GIZMOVIEWER: '/gizmo-viewer',
  GIZMOWEBWIDGET: '/open-gizmo-web-widget',
  NEWREPORTWIDGET: '/new-report-widget',
};

// export const API_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL;
// export const API_BASE_URL =
//   import.meta.env.VITE_HYBRID_MODE == 'true'
//     ? window.location.origin + '/'
//     : import.meta.env.VITE_BACKEND_BASE_URL;

const host = window.location.hostname.toLowerCase();
export const API_BASE_URL =
  getEnv("REACT_APP_HYBRID_MODE") === "true"
    ? window.location.origin + "/"
    : resolveBackendForHost(host).backendUrl ||
      getEnv("REACT_APP_BACKEND_BASE_URL");
      
export const DICOM_ACCEPTOR_BASE_URL = getEnv("REACT_APP_DICOM_ACCEPTOR_BASE_URL");
export const ADVANCE_VIEWER_BASE_URL = getEnv("REACT_ADVANCEVIEWER_BASE_URL");

export const SERVICEURL = 'jwtServices';

export const SHARED_SERVICEURL = 'sharedServices';

export const APIs = {
  ADMINUSERLIST: 'jwtServices/user-list',
  ADDADMINUSER: 'jwtServices/user-save',
  CHANGEUSERSTATUS: 'jwtServices/change-status/user',
  CHANGEUSERLOCKSTATUS: 'jwtServices/change-lock/user',
  PASSWORDRESET:'jwtServices/password-reset/admin',
  VIEWADMINUSER: 'jwtServices/user-view',
  EDITADMINUSER: 'jwtServices/user-update',
  LOADUSERDATA: 'jwtServices/load-by-username',
  ADDHOSPITAL: 'jwtServices/firm/add-new',
  EDITHOSPITAL: 'jwtServices/firm/save-edit-details',
  ADDPROJECT: 'jwtServices/project/add-new',
  EDITPROJECT: 'jwtServices/project/save-edit-details',
  GETHEADERIMAGE: 'jwtServices/firm/get-header-image',
  GETFOOTERIMAGE: 'jwtServices/firm/get-footer-image',
  GETSIGNATUREIMAGE: 'jwtServices/firm/get-signature-image',
  GETWATERMARKIMAGE: 'jwtServices/firm/get-watermark-image',
  MODALITYLIST: 'jwtServices/modality/list',
  LLMAGENTLIST: 'jwtServices/llmreport/agentic-report-agents',
  ADD_PERSONAL_TEMPLATE: "jwtServices/api/agentic/template/add-personal-template",
  LLM_REFRESH_MAPPINGS: "jwtServices/llmreport/refresh",
  SUBMODALITYLIST: 'jwtServices/sub-modality/list',
  SAVESUBMODALITY: 'jwtServices/sub-modality/save',
  EDITSUBMODALITY: 'jwtServices/sub-modality/edit',
  ERRORCODELIST: 'jwtServices/errorList/list',
  ERRORSEARCHLIST: 'jwtServices/errorList/search',
  ERRORSTUDYLIST: 'jwtServices/errorList/error',
  PATHALOGYLIST: 'jwtServices/pathology/list2',
  AUDITLOGSEARCH: 'jwtServices/audit/search',
  ORCHESTRATORSEARCH: 'jwtServices/orchestrator/search',
  ISSUESTATUSSEARCH : 'jwtServices/issuetracker/search', 
  UPDATE_ISSUE_STATUS: 'jwtServices/issuetracker/update/status',
  UPDATE_ISSUE_STATUS_ALL: 'jwtServices/issuetracker/update/status/all',
  AUDITLOGSLIST: 'jwtServices/audit/logs',
  ORCHESTRATORLOGSLIST: 'jwtServices/orchestrator/logs',
  REDIRECTLOGOUT: '/',
  FIRMLIST: 'jwtServices/firm/list',
  PROJECTLIST: 'jwtServices/project/list',
  PROVIDERLIST: 'jwtServices/provider-list',
  FIRMCHANGESTATUS: 'jwtServices/firm/change-status',
  VIEWFIRM: 'jwtServices/firm/view-firm',
  EDITFIRMSETTINGS: 'jwtServices/firm/edit-firm-settings',
  SAVEFIRMSETTINGS: 'jwtServices/firm/save-edit-firm-settings',
  PREVIEWSAMPLEREPORT: 'jwtServices/firm/preview-sample-report',
  ACITVATE_DEACTIVE: 'jwtServices/connection-process/activate-deactivate',
  CONNECTTOPROVIDER:
    'jwtServices/connection-process/create-connection/connect-to-provider',
  CONNECTTOCLIENT:
    'jwtServices/connection-process/create-connection/connect-to-client',
  CHANGEFIRMSTATUS: '/firm/change-status',
  USERLIST: 'jwtServices/user-list',
  NEWUSER: 'jwtServices/user-new',
  EDITUSER: 'jwtServices/user-edit',
  ADDUSER: 'jwtServices/user-save',
  VIEWUSER: 'jwtServices/user-view',
  UPDATEUSER: 'jwtServices/user-update',
  USERPROFILEUPDATE: "jwtServices/user-profile-update",
  SIGNATUREIMAGE: 'jwtServices/radiologist/api/get-signature-image',
  VIEWPROVIDER: 'jwtServices/provider-view',
  CHANGEPWD: 'jwtServices/user/changepwd',
  GETSTUDYLIST: '/studylist',
  GETPRIORSLIST: '/studylist/get/priors',
  GETPATIENTDATA: '/patient/get',
  GETSTUDYDATA: '/study/api/get',
  GETSERIESBYUID: '/study/series/get',
  GETOPENAPISTUDYDATA: '/open-api-react/loadStudyViewer',
  GETPRIORSDATA: '/patient/get',
  GETIMAGEDATA: 'jwtServices/study/image/get/',
  GETIMAGEDATAWITHFILESIZE: 'jwtServices/study/imageWithFileSize/get/',
  GETPATIENTREPORT: 'jwtServices/study/report/get-patient-report',
  GETREPORTTEMPLATE: 'jwtServices/study/report/get-report-templates',
  DOWNLOADREPORT: 'jwtServices/study/report/download/',
  DOWNLOADAIREPORT: 'jwtServices/study/report/download/ai/pdf/',
  PREVIEWREPORT: 'jwtServices/study/report/preview/pdf/',
  PREVIEWREPORTWITHKEYIMAGE: 'jwtServices/study/report/preview/pdf/pdfwithkeyimage/',
  PREVIEWREPORTVERSION: 'jwtServices/study/report/version/preview/pdf/',
  PREVIEWWORDREPORTHISTORY: "jwtServices/study/report/history/preview/pdf/",
  VIEWREPORT: '/study/report/view/pdf/',
  SAVEREPORT: 'jwtServices/study/report/save',
  REPORT_AUTOSAVE: 'jwtServices/study/report/autosave',
  REPORT_SNAPSHOT_CHECK: 'report-snapshot-check',
  DISCARD_REPORT_SNAPSHOT: 'jwtServices/study/report/snapshot/discard',
  SUBMITREPORT: 'jwtServices/study/report/submit',
  VALIDATEREPORTSUBMIT: 'jwtServices/study/report/validate-submit',
  GETSTUDYREPORT: 'jwtServices/study/report/fetch',
  GETS10REPORT: 'jwtServices/study/report/fetchS10Report',
  GETALLPATHOLOGY: 'jwtServices/study/all-annotation-stuff',
  GETSELECTEDPATHOLOGY: 'jwtServices/study/selected-annotation-stuff',
  DOWNLOADSTUDYZIP: '/study/downloadStudy',
  DOWNLOADSTUDYPPT: '/study/downloadPpt',
  DOWNLOADSTUDYPPTASYNC: '/study/downloadPptAsync',
  ASSIGNSTUDY: '/study/assignme',
  REGENERATEREPORT: '/study/options/api/multiple-report-new-annotation',
  GENERATERSNAREPORT: '/study/options/api/smart-reporting',
  GETHTMLTEMPLATE: '/study/report/get-html-text',
  QCPASS: '/study/report/qcFail',
  QCFIXREASSIGN: '/study/report/qcFixer/reassign',
  QCPROVIDERLIST: '/studylist/getqcproviders',
  GENERATECTBRAIN: '/study/options/api/smart-report',
  HISTORYDOWNLOAD: '/study/history/download',
  LOGVIEWORIGINAL: '/study/logging',
  COMMUNICATIONDATA: '/feedback/fetch',
  SENDFEEDBACK: '/feedback/add',
  REPORTTEMPLATESLIST: 'jwtServices/report/list/template',
  REPORTTEMPLATESLISTBYTAB: '/report/templates/list',
  ADDREPORTTEMPLATE: 'jwtServices/report/add/save-template',
  EDITREPORTTEMPLATE: 'jwtServices/report/edit/template',
  EDITREPORTTEMPLATEAPI: 'jwtServices/report/edit/update-template',
  DELETEREPORTTEMPLATE: 'jwtServices/report/deleteReport',
  REPORTRADIOLOGIST: 'jwtServices/report/list/radiologist',
  STARTDOWNLOADSTUDYZIP: '/study/downloadStudyAsync',
  FETCHDOWNLOADPROGRESS: '/study/download/fetchProgress',
  DOWNLOADCOMPLETEDFILE: '/study/downloadFile',
  REPORTFIRMS: 'jwtServices/report/list/firm',
  REPORTCLIENTS: 'jwtServices/report/list/clients',
  GETHEADERTEMPLATE: 'jwtServices/firm/list/header/template',
  UPDATEDEFAULTHEADERTEMPLATE: 'jwtServices/firm/edit/default-template',
  EDITHEADERTEMPLATE: 'jwtServices/firm/edit/header-template',
  LISTFIRMHEADERTEMPLATE: 'jwtServices/firm/edit/hospital-header-template',
  USERPREFERENCE: 'jwtServices/user/preference',
  SAVEUSERPREFERENCE: 'jwtServices/user/savepreference',
  USERPROFILE: 'jwtServices/user/profile',
  AVAILABLESUPPORTMEMBERS: 'jwtServices/support-member/available',
  BARCHART: 'jwtServices/charts/bar/',
  PIECHART: 'jwtServices/charts/pie/',
  ANALYTICSDATA: 'jwtServices/charts/analytics',
  STUDYCOUNTS: 'jwtServices/charts/getstudycounts',
  CLIENTWARNINGSTATUS: 'jwtServices/firm/client-warning/status',
  GETUNASSIGNREASONCOUNT: '/unassignedReason',
  REFRESHTOKEN: 'auth/refreshToken',
  DEEPGRAMTOKEN: 'jwtServices/deepgram/token',
  VAPISESSION: 'jwtServices/vapi/session',
  RAICREDENTIALS: 'jwtServices/rai/credentials',
  GETFISTOLUGRAM: 'jwtServices/study/getFistulogramPath',
  ADVANCEVIEWERSTATUS: '/study/advviewer/getstatus',
  DOWNLOADFISTOLUGRAM: '/study/downloadFistulogram',
  UPLOADFISTOLUGRAM: '/study/uploadFistulogram',
  DELETEFISTOLUGRAM: '/study/deleteFistulogram',
  GETFIBROID:      'jwtServices/study/getFibroidPath',
  DOWNLOADFIBROID: '/study/downloadFibroid',
  UPLOADFIBROID:   '/study/uploadFibroid',
  DELETEFIBROID:   '/study/deleteFibroid',
  GETSTUDYSTATUS: '/study/get-status',
  GETSTUDYORDERDETAILS: '/study/order/details',
  GETRETURNSTATUS: '/study/get-radiologist-return-status',
  SENDOLDSTUDYREQUEST: '/study/send-old-study-request',
  CHECKARCHIVEDSTUDYACCESSREQUEST: '/check-archived-study-access-request',
  SENDARCHIVEDSTUDYACCESSREQUEST: '/archived-study-access-request',
  ACCEPTSTUDYACCESSREQUEST: '/accept-study-access-request',
  REJECTSTUDYACCESSREQUEST: '/reject-study-access-request',
  SUPERVISORASSIGNME: '/study/supervisor/assignme',
  TYPISTASSIGNME: '/study/typist/assignme',
  TIMESPENDBYRADIOLOGIST: '/radiologist/timeSpent',
  GETMSWORDREPORTHISTORY: '/getReportHistory',
  FETCHUPLOADPROCESSSTATUS: '/study/upload/process-status/',
  MARKEDASSUSPECT: '/study/mark-as-suspected',
  GENERATEOTP: 'auth/generate-otp',
  GENERATEOTP2FA: 'auth/generate-otp-2fa',
  AUTHENTICATEOTP: 'auth/authenticate-otp',
  AUTHENTICA2FATEOTP: 'auth/authenticate-otp-2fa',
  RESETPASSWORD: 'auth/update-pwd',
  GETFIRMEMAIL: '/getfirmemail',
  GETFIRMDATAPRESENT: '/firm/share-report-link-enabled',
  GETPAYMENTSTATUS: '/vdc/study/get-payment-status',
  SENDREPORTTOLIMS: '/study/lims/send/report',
  ACTIVERADIOLOGISTVIEWING: '/radiologist/active',
  FIRMMODALITYLIST: '/firm/get-modality-list',
  DOWNLOADBILL: 'jwtServices/billing/detailed/sheet-download',
  DOWNLOADAUDITLOG: '/audit/csvexport',
  DOWNLOADORCHESTRATORLOG: '/orchestrator/csvexport',
  DOWNLOADERRORLISTLOG: '/errorList/csvexport',
  GETBILLINGHOSPITALLIST: 'jwtServices/billing/getHospitalList',
  AUTHENTICATEGOOGLEUSER: 'auth/authenticate-google-user',
  USERSETTINGS: '/user-settings',
  SUBMODALITYLISTNUMBERS: '/firm/get-sub-modality-list-numbers',
  DOWNLOADMANUAL: 'jwtServices/about-us/manual/download',
  PEERREVIEWDOWNLOAD:'/peer/review/download',
  GETSHAREDSTUDYDATA: '/study/get',
  // The share-link counterpart of GETPRIORSDATA: the shared study first, then the
  // priors that link offers. Only called when the study route said sharePriors.
  GETSHAREDSTUDYPRIORSDATA: '/study/priors/get',
  GETSHAREDSTUDYADVACNEVIEWERURL: '/study/get/advanceViewerUrl',
  GETSHAREDSTUDYBYPASS: '/study/share/password/allowed',
  VALIDATESHAREDSTUDYPASSWORD: '/study/share/password/validate',
  GETSHAREDHPV2DOCUMENT: '/study/hangingprotocol/effective',
  GETSHAREDIMAGEDATA: 'sharedServices/study/image/get/',
  GETMOBILESTUDYDATA: '/study/api/mobile/get',
  FETCHCSVDOWNLOADPROGRESS: '/studylist/csvexport/fetchProgress',
  FETCHEXCELDOWNLOADPROGRESS: '/studylist/csvexport/fetchProgress',
  DOWNLOADCOMPLETEDCSVFILE: '/studylist/csvexport/downloadFile',
  DOWNLOADCOMPLETEDEXCELFILE: '/studylist/csvexport/downloadFile',
  GETUPLOADSTUDYCLIENTS: '/getClient',
  GETUPLOADSTUDYINITIALDATA: '/uploadStudyList',
  GETWORDSESSION:"/study/report/get/word-session",
  OPENWORD: "ms-word/download/doc/",
  TYPISTADDSTUDY:"/typist/add-study",
  GETTYPISTDETAILS : "/typist-assignment-info",
  UNASSIGNTYPIST: "/unassign/typist",
  ECHOPACSNODE: 'jwtServices/echo/node',
  GETPACSNODE:"/study/get/nodes",
  SENDTOPACSNODE:"/study/send/to/nodes",
  STUDYINFORMATIONFROMPACS: '/vdc/study/pacs/information',
  PULLPACSSTUDYREPORT: '/vdc/study/report/pull',
  PUSHIMAGESTOPACS: '/vdc/study/image/push',
  GETRADIOLOGISTFORPEERREVIEW:"/peer/review/radiologist/list",
  GETEVALUATORS:"/peer/review/evaluator/list",
  ASSIGNFORPEERREVIEW:"/peer/review/radiologist/assign",
  ASSIGNFOREVALUATION:"/peer/review/evaluator/assign",
  BILLINGDATADOWNLOADEXCEL:"/api/download/billing/data1",
  SENDHL7:"/study/send/hl7",
  SENDAIREPORT:"/study/send/aireport",
  ADDREPORTTEMPLATERESTRICTIONS: "/report/template/restriction",
  MODALITYLISTFORRESTRICTION: "/report/template/modality/restriction",
  PACSQUEUELIST: 'jwtServices/pacs/queue/list',
  REFRESHQUEUEITEM: 'jwtServices/pacs/queue/item/refresh',
  CANCELQUEUEITEM: 'jwtServices/pacs/queue/item/cancel',
  SWAPQUEUEPRIORITY: 'jwtServices/pacs/queue/swapPriority',
  REFRESHQUEUEList: 'jwtServices/pacs/queue/list/refresh',
  PACSQUEUECSVEXPORT: 'jwtServices/pacs/queue/request/csvexport',
  PACSQUEUECSVEXPORTPROGRESS: 'jwtServices/pacs/queue/request/csvexport/fetchProgress',
  PACSQUEUECSVEXPORTDOWNLOAD: 'jwtServices/pacs/queue/request/csvexport/downloadFile',
  AIREQUESTLIST: 'jwtServices/ai/request/list',
  AIEXPORTCSVSTATUS: '/ai/request/csvexport/status',
  AIEXPORTCSVINITIATE: '/ai/request/csvexport',
  AIEXPORTCSVPROGRESS: '/ai/request/csvexport/fetchProgress',
  AIEXPORTCSVDOWNLOAD: '/ai/request/csvexport/downloadFile',
  GATEWAYSTUDYSTATUS: '/gateway/upload/status',
  SWITCHDATA: '/switchdata',
  DOWNLOADTRIGGER: '/download/trigger',
  REGENERATELLMREPORT: '/llmreport/regenerate',
  HP_GET_OPTIONS_LIST:'jwtServices/hangingprotocol/getoptionslist',
  HP_ADD:'jwtServices/hangingprotocol/add',
  HP_GET:'jwtServices/hangingprotocol/get',
  HP_GET_LIST:'jwtServices/hangingprotocol/hplist',
  HP_EDIT:'jwtServices/hangingprotocol/edit',
  HP_ACITVATE_DEACTIVE: 'jwtServices/hangingprotocol/updatestatus',
  HP_DETETE:'jwtServices/hangingprotocol/delete',
  
  HP_GET_OPTIONS_LIST_SYS:'jwtServices/syshangingprotocol/getoptionslist',
  HP_GET_LIST_SYS:'jwtServices/syshangingprotocol/hplist',
  HP_ADD_SYS:'jwtServices/syshangingprotocol/add',
  HP_GET_SYS:'jwtServices/syshangingprotocol/get',
  HP_EDIT_SYS:'jwtServices/syshangingprotocol/edit',
  HP_ACITVATE_DEACTIVE_SYS: 'jwtServices/syshangingprotocol/updatestatus',
  HP_DETETE_SYS:'jwtServices/syshangingprotocol/delete',

  // Hanging Protocol V2 — the MedDream hangingProtocolsV2 interchange format.
  // Scope (USER/SYSTEM) travels in the request body, so one set of endpoints
  // covers both, unlike the v1 pair above.
  HPV2_GROUPS: 'jwtServices/hangingprotocolv2/groups',
  HPV2_GROUP_GET: 'jwtServices/hangingprotocolv2/group/get',
  HPV2_GROUP_SAVE: 'jwtServices/hangingprotocolv2/group/save',
  HPV2_GROUP_DELETE: 'jwtServices/hangingprotocolv2/group/delete',
  HPV2_GROUP_STATUS: 'jwtServices/hangingprotocolv2/group/updatestatus',
  HPV2_GROUP_REORDER: 'jwtServices/hangingprotocolv2/group/reorder',
  HPV2_PROTOCOL_GET: 'jwtServices/hangingprotocolv2/protocol/get',
  HPV2_PROTOCOL_SAVE: 'jwtServices/hangingprotocolv2/protocol/save',
  HPV2_PROTOCOL_DELETE: 'jwtServices/hangingprotocolv2/protocol/delete',
  HPV2_PROTOCOL_REORDER: 'jwtServices/hangingprotocolv2/protocol/reorder',
  HPV2_PROTOCOL_MOVE: 'jwtServices/hangingprotocolv2/protocol/move',
  HPV2_DOCUMENT_EXPORT: 'jwtServices/hangingprotocolv2/document/export',
  HPV2_DOCUMENT_EFFECTIVE: 'jwtServices/hangingprotocolv2/document/effective',
  HPV2_DOCUMENT_IMPORT: 'jwtServices/hangingprotocolv2/document/import',
  HPV2_DOCUMENT_PUBLISH: 'jwtServices/hangingprotocolv2/document/publish',
  HPV2_SYSTEM_PUBLISH: 'jwtServices/hangingprotocolv2/document/system/publish',
  HPV2_SYSTEM_STATUS: 'jwtServices/hangingprotocolv2/document/system/status',

  ADVLICENSEUSERLIST: 'jwtServices/adv/license/list',
  ADVLICENSESAVE: 'jwtServices/adv/license/save',
  GETFORMATTEDREPORT: '/study/report/formatted',
  DOWNLOAD_AGENTIC_LOG: 'jwtServices/llmreport/agentic-log-download',
  SC_DICOM_UPLOAD : 'jwtServices/upload/sc-dicom',
  SC_DICOM_LIBRARY : 'jwtServices/sc-dicom/library',
  GETONLINERADIOLOGIST:'/radiologistanalytics/getOnlineRadiologist',
  GETONLINEQCSUPERVISOR:'/radiologistanalytics/getOnlineQcSupervisor',
  GET_BUCKET_DETAILS: 'jwtServices/firm/get-bucket-details',
  GET_CONFIGURATION_DETAILS: 'jwtServices/firm/get-configuration-details',
  GET_ACTIVE_SESSIONS: 'auth/sessions',
  LOGOUT_SESSION: 'auth/sessions/logout',
  LOGOUT_ALL_SESSIONS: 'auth/sessions/logoutAll',
  AINODELIST: 'jwtServices/ai/node/list',
  AINODEDELETE: 'jwtServices/ai/node/delete',
  AINODESAVE: 'jwtServices/ai/node/save',
  EXTERNALFIRMLIST: 'jwtServices/external/firm/list',
  SAVECLIENTCREDNTIALS: 'jwtServices/external/client-credentials',
  UPDATECLIENTCREDENTIALS:'jwtServices/external/client-credentials',
  GENERATESECRET: 'jwtServices/external/client-credentials',
  EXTERNALFIRMSAVE: 'jwtServices/external/firm/save',
  EXTERNALFIRMREQUESTLIST: 'jwtServices/external/firm/request/list',
  EXTERNALFIRMCSVEXPORT: '/external/firm/request/csvexport',
  EXTERNALFIRMCSVEXPORTPROGRESS: '/external/firm/request/csvexport/fetchProgress',
  EXTERNALFIRMCSVEXPORTDOWNLOAD: '/external/firm/request/csvexport/downloadFile',
  EXTERNALDICOMPUSH: '/external/firm/dicom/push',
  SSE_SUBSCRIBE: 'jwtServices/sse/subscribe/',
  RETURNREASONCATEGORYLIST: 'jwtServices/return/reason/list',
  RETURNREASONDELETE: 'jwtServices/return/reason/delete',
  RETURNREASONSAVE: 'jwtServices/return/reason/save',
  RETURNREASONSWAPORDER: 'jwtServices/return/reason/swapOrder',
  DATA_DUMP: 'jwtServices/internal/datadump',
  LOGAGENTICEVENT: '/llmreport/event-log',
  GATEWAYHEALTH: 'jwtServices/api/gateways'
};

export const STORAGE_TYPE = {
  HOT_STORAGE: 1,
  COLD_STORAGE: 2,
};

export const LOGIN_FAILED_REASON = {
  LOCKED: 'LOCKED',
  INVALID: 'INVALID',
  ONE_ATTEMPT: 'ONE_ATTEMPT_REMAINING',
  TWO_ATTEMPTS: 'TWO_ATTEMPT_REMAINING',
  DEACTIVATED: "DEACTIVATED",
  RATE_LIMITED: "RATE_LIMITED"
};

export const BASIC_VIEWER_URL = '/study/load/switch/'
export const ADVANCE_VIEWER_URL = "/study/load/nonXrayAdvanceViewer/"
export const REACT_ADVANCE_VIEWER_URL = "/new/study/load/nonXrayAdvanceViewer/"
export const BASIC_STUDYLIST = "/studylist"
export const DEFAULT_ADVANCE_VIEWER_MODALITIES = ["CT", "MR", "MG", "ECG", "PT", "NM"];
export const ADVANCE_VIEWER_MODALITIES = getEnvList(
  "REACT_APP_ADVANCE_VIEWER_MODALITIES",
  DEFAULT_ADVANCE_VIEWER_MODALITIES
);
// Modalities whose studies stay openable when the study reports 0 images:
// encapsulated documents are carried as documents, not as image instances.
export const ZERO_IMAGE_ALLOWED_MODALITIES = ["DOC"];
export const HIDE_LOCK_ICON_TABS = ["qcfix"];
export const HIDE_ASSIGN_DROPDOWN_TABS = ["closed","qcfix","qcreview","qcreviewAssigned","qcverify"]
export const QC_TABS = ["qcreview","qcreviewAssigned","qcverify"];
export const QC_TABS_NAME = ["qcreview","qcreviewAssigned","qcverify","qcfix"];
export const SHOW_RETURNED_ROLES = ["ADMIN","FIRM_ADMIN","SUPERVISOR", "HOSPITAL_USER","HOSPITAL_DOCTOR"];
export const HIDE_ALERT_RAISE = ["HOSPITAL_USER","HOSPITAL_DOCTOR"]
export const SHOW_EXTERNAL_REPORTING_TO_USER = ["ADMIN","FIRM_ADMIN","RADIOLOGIST","TYPIST"]
export const HIDE_FILTER_FOR_ROLES = ["HOSPITAL_USER","HOSPITAL_DOCTOR","TYPIST"]
export const SHOW_SAVED_TAG_TABS = ["unreported","critical","library"];
export const NONXRAYMODALITIES = ["CR","DX"];
export const HIDE_PRIORITY_FILTER= ["TYPIST"];

export const dicomBaseURL = API_BASE_URL?.startsWith('https')
  ? API_BASE_URL.replace('https', 'wadouri') + APIs.GETIMAGEDATA
  : API_BASE_URL?.replace('http', 'wadouri') + APIs.GETIMAGEDATA;

export const dicomWebURL = API_BASE_URL?.startsWith('https')
? API_BASE_URL.replace('https', 'dicomweb') + APIs.GETIMAGEDATA
: API_BASE_URL.replace('http', 'dicomweb') + APIs.GETIMAGEDATA;

// DICOMweb base for backend per-frame WADO-RS endpoint. Sits under
// /jwtServices/* so the existing JWT cookie filter protects it without any
// additional security config.
export const DICOMWEB_BASE = `${API_BASE_URL}jwtServices/dicomweb`;
// const dicomBaseURL = API_BASE_URL.startsWith("https")
//   ? API_BASE_URL.replace("https", "web") + APIs.GETIMAGEDATA
//   : API_BASE_URL.replace("http", "web") + APIs.GETIMAGEDATA;
export const imageBaseURL = API_BASE_URL?.startsWith('https')
  ? API_BASE_URL.replace('https', 'web') + APIs.GETIMAGEDATA
  : API_BASE_URL?.replace('http', 'web') + APIs.GETIMAGEDATA;

export const ACTIONS = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
};

export const USERTYPES = {
  FIRMADMIN: "FIRM_ADMIN",
  ADMIN: "ADMIN",
  SUPERVISOR: "SUPERVISOR",
  FIRMDOCTOR: "HOSPITAL_DOCTOR",
  FIRMTECHNICIAN: "HOSPITAL_USER",
  RADIOLOGIST: "RADIOLOGIST",
  TYPIST:"TYPIST"
};

export const TYPEOFUSER = {
  PROVIDER: 'Provider',
  RADIOLOGIST: 'Radiologist',
  CLIENT: 'Client',
};

export const REPORTSTATUS = [{ 1: 'Preliminary' }, { 2: 'Submit' }];

export const REPORTDONESTATUS = {
  UNREPORTED: 0,
  SAVED: 1,
  /** Rollout alias: existing Saved (1) is treated as Preliminary. */
  PRELIMINARY: 1,
  REPORTED: 2,
  QC_REVIEW: 3,
  QC_FIX: 4,
  QC_VERIFY: 5,
  /** Draft / Saved tab (study list). */
  DRAFT: 6,
  PRELIMINARY_QC_REVIEW: 7,
  PRELIMINARY_QC_FIX: 8,
  PRELIMINARY_QC_VERIFY: 9,
};

/** True when reportDoneStatus is the official Preliminary state (status 1). */
export const isPreliminaryReportStatus = (status) =>
  status === REPORTDONESTATUS.SAVED || status === REPORTDONESTATUS.PRELIMINARY;

/** True when reportDoneStatus is Draft (status 6). */
export const isDraftReportStatus = (status) =>
  status === REPORTDONESTATUS.DRAFT;

export const RADIOLOGISTTYPE = ['Panel', 'Expert', 'Customer'];

export const BAR_CHART_COLORS = [
  'hsl(33, 80%, 76%)',
  'hsl(103, 77%, 74%)',
  'hsl(322, 85%, 80%)',
];

export const BAR_CHART_DOT_COLORS = [
  'hsl(33, 87%, 69%)',
  'hsl(103, 82%, 66%)',
  'hsl(348, 82%, 56%)',
];

export const PIE_CHART_COLORS = [
  'hsl(350, 70%, 50%)',
  'hsl(104, 70%, 50%)',
  'hsl(139, 70%, 50%)',
  'hsl(218, 70%, 50%)',
  'hsl(177, 70%, 50%)',
  'hsl(270, 70%, 50%)',
];

export const BAR_CHART_COLORS_AI_RESULT = [
  '#9E9E9E',  // No AI Result (gray)
  '#6A89A7',  // AI Result Pending
  'green',  // Normal (green)
  '#E4D00A	',  // Medium (yellow)
  'orange',  // High (orange)
  'red'   // Critical (red)
];


export const BAR_CHART_COLORS_ALLMODALITIES = 'hsl(238, 70%, 50%)';

// OLD: max 3x3 layout grid
// export const VIEWPORT_ROW = 3;
// export const VIEWPORT_COLUMN = 3;
// NEW: support up to a 4x4 layout in the basic viewer (desktop + mobile).
export const VIEWPORT_ROW = 4;
export const VIEWPORT_COLUMN = 4;

export const TOOLS = [
  {
    key: StackScrollTool.toolName,
    NotFor: [],
    name: 'viewer.tools.stack-scroll',
    isEvent: true,
    eventName: 'EVENT_BASIC_STACK_SCROLL_TOOL_USED',
  },
  {
    key: WindowLevelTool.toolName,
    NotFor: [],
    name: 'viewer.tools.window',
    isEvent: true,
    eventName: 'EVENT_BASIC_WW_WL_TOOL_USED',
  },
  {
    key: ZoomTool.toolName,
    NotFor: [],
    name: 'viewer.tools.zoom',
    isEvent: true,
    eventName: 'EVENT_BASIC_ZOOM_TOOL_USED',
  },
  {
    key: PanTool.toolName,
    NotFor: [],
    name: 'viewer.tools.pan',
    isEvent: true,
    eventName: 'EVENT_BASIC_PAN_TOOL_USED',
  },
  {
    key: LengthTool.toolName,
    NotFor: [],
    name: 'viewer.tools.length',
    isEvent: true,
    eventName: 'EVENT_BASIC_LENGTH_MEASUREMENT_TOOL_USED',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
    isEvent: true,
    eventName: 'EVENT_BASIC_BIDIRECTIONAL_MEASUREMENT_TOOL_USED',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.ellipse',
    isEvent: true,
    eventName: 'EVENT_BASIC_ELLIPTICAL_ROI_TOOL_USED',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
    isEvent: true,
    eventName: 'EVENT_BASIC_RECTANGLE_ROI_TOOL_USED',
  },
  {
    key: 'FreeRotate',
    NotFor: [],
    name: 'viewer.tools.free-rotate',
    isEvent: false,
  },
];

export const MPR_TOOL_OBJECT = {
  key: 'MPR',
  NotFor: ['CR', 'DX', 'SR', 'RG', 'SC', 'DOC'],
  name: 'viewer.tools.mpr',
};

export const COMPARE_TOOL_OBJECT = {
  key: 'Compare',
  NotFor: [],
  name: 'viewer.tools.compare',
};

export const DROPDOWNTOOLS = [
  {
    key: 'Reset',
    NotFor: [],
    name: 'viewer.tools.reset',
    isEvent: true,
    eventName: 'EVENT_BASIC_RESET_TOOL_USED',
  },
  {
    key: 'Invert',
    NotFor: [],
    name: 'viewer.tools.invert',
    isEvent: true,
    eventName: 'EVENT_BASIC_INVERT_TOOL_USED',
  },
  {
    key: ProbeTool.toolName,
    NotFor: [],
    name: 'viewer.tools.probe',
    isEvent: true,
    eventName: 'EVENT_BASIC_PIXEL_PROBE_TOOL_USED',
  },
  {
    key: ArrowAnnotateTool.toolName,
    NotFor: [],
    name: 'viewer.tools.annotation',
    isEvent: true,
    eventName: 'EVENT_BASIC_TEXT_TOOL_USED',
  },
  {
    key: ReferenceLinesTool.toolName,
    NotFor: ['CR', 'DX', 'US', 'SR', 'SC', 'DOC'],
    name: 'viewer.tools.reference',
    isEvent: true,
    eventName: 'EVENT_BASIC_REFERENCE_LINES_TOOL_USED',
  },
  {
    key: 'Synchronize',
    NotFor: ['CR', 'DX', 'US', 'SR', 'SC', 'DOC'],
    name: 'viewer.tools.synchronize',
    isEvent: true,
    eventName: 'EVENT_BASIC_SYNCHRONIZE_TOOL_USED',
  },
  {
    key: 'CINE',
    NotFor: [], //['CR', 'DX', 'US', 'SR', 'SC'],
    name: 'viewer.tools.cine',
    isEvent: true,
    eventName: 'EVENT_BASIC_PLAY_CLIP_TOOL_USED',
  },
  {
    key: AngleTool.toolName,
    NotFor: [],
    name: 'viewer.tools.angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_ANGLE_MEASUREMENT_TOOL_USED',
  },
  {
    key: CobbAngleTool.toolName,
    NotFor: [],
    name: 'viewer.tools.cobb-angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_COBB_ANGLE_MEASUREMENT_TOOL_USED',
  },
  {
    key: MagnifyTool.toolName,
    NotFor: [],
    name: 'viewer.tools.magnify',
    isEvent: true,
    eventName: 'EVENT_BASIC_MAGNIFY_TOOL_USED',
  },
  {
    key: PlanarFreehandROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.planarfreehandroi',
    isEvent: true,
    eventName: 'EVENT_BASIC_PLANARFREEHAND_ROI_TOOL_USED',
  },
  {
    key: CircleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.circleroi',
    isEvent: true,
    eventName: 'EVENT_BASIC_CIRCLE_ROI_TOOL_USED',
  },
  /*{
    key: PanTool.toolName,
    NotFor: [],
    name: 'viewer.tools.pan',
    isEvent: true,
    eventName: 'EVENT_BASIC_PAN_TOOL_USED',
  },*/
  {
    key: LengthTool.toolName,
    NotFor: [],
    name: 'viewer.tools.length',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_LENGTH_MEASUREMENT_TOOL_USED',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_BIDIRECTIONAL_MEASUREMENT_TOOL_USED',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.ellipse',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ELLIPTICAL_ROI_TOOL_USED',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_RECTANGLE_ROI_TOOL_USED',
  },
  {
    key: 'SpineLabelling',
    NotFor: [],
    name: 'viewer.tools.spine-labelling',
    isEvent: false,
  },
  {
    // DICOM Overlay Planes (group 60xx) — scanner-drawn graphics such as
    // Siemens AutoAlign spine level labels. A show/hide preference, not a
    // mouse tool; only ever visible on images that actually carry an overlay.
    key: 'DicomOverlay',
    NotFor: [],
    name: 'viewer.tools.dicom-overlay',
    isEvent: true,
    eventName: 'EVENT_BASIC_DICOM_OVERLAY_TOGGLED',
  },
  {
    // MedDream-style calibration line. Available for all modalities (the user
    // calibrates by drawing a line of known real-world length).
    key: 'CalibrationLine',
    NotFor: [],
    name: 'viewer.tools.calibration-line',
    isEvent: true,
    eventName: 'EVENT_BASIC_CALIBRATION_LINE_TOOL_USED',
  },

];

export const PASSIVE_TOOLs = [
  LengthTool.toolName,
  BidirectionalTool.toolName,
  EllipticalROITool.toolName,
  PanTool.toolName,
  ProbeTool.toolName,
  RectangleROITool.toolName,
  ArrowAnnotateTool.toolName,
  AngleTool.toolName,
  CobbAngleTool.toolName,
  PlanarFreehandROITool.toolName,
  CircleROITool.toolName,
  'CalibrationLine',
];

export const VIEWPORT_TOOLS = [
  'Invert',
  'RotateRight',
  'RotateLeft',
  'FlipVertical',
  'FlipHorizontal',
  'AlignLeft',
  'AlignRight',
  'AlignCenter',
  'Reset',
  'CINE',
  'Synchronize',
  'ReferenceLines',
  'SpineLabelling',
  'DicomOverlay',
];

export const HIDE_TOOL_SMALL_SCREEN = [
  EllipticalROITool.toolName,
  BidirectionalTool.toolName,
  RectangleROITool.toolName,
  LengthTool.toolName,
];

export const MPR_TOOLS = [
  {
    key: StackScrollTool.toolName,
    name: 'viewer.tools.stack-scroll',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_STACK_SCROLL_TOOL_USED',
  },
  {
    key: ZoomTool.toolName,
    name: 'viewer.tools.zoom',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ZOOM_TOOL_USED',
  },
  {
    key: WindowLevelTool.toolName,
    name: 'viewer.tools.window',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_WW_WL_TOOL_USED',
  },
  {
    key: PanTool.toolName,
    name: 'viewer.tools.pan',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PAN_TOOL_USED',
  },
  {
    key: CrosshairsTool.toolName,
    name: 'viewer.tools.crosshairs',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_CROSSHAIRS_TOOL_USED',
  },
  {
    key: PlanarRotateTool.toolName,
    name: 'viewer.tools.rotate-3d',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ROTATE_3D_TOOL_USED',
  },
  {
    key: 'Reset3D',
    name: 'viewer.tools.reset-3d',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_RESET_3D_TOOL_USED',
  },
];

// Overflow tools shown in the MPR toolbar's "More" menu — measurement,
// annotation, reference-line, and CINE tools that don't need to be inline.
export const MPR_MORE_TOOLS = [
  {
    key: ReferenceLinesTool.toolName,
    name: 'viewer.tools.reference',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_REFERENCE_LINES_TOOL_USED',
  },
  {
    key: LengthTool.toolName,
    //name: 'viewer.tools.length',
    name: 'viewer.tools.length-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_LENGTH_MEASUREMENT_TOOL_USED',
  },
  {
    key: BidirectionalTool.toolName,
    name: 'viewer.tools.bidirectional',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_BIDIRECTIONAL_MEASUREMENT_TOOL_USED',
  },
  {
    key: EllipticalROITool.toolName,
    //name: 'viewer.tools.ellipse',
    name: 'viewer.tools.ellipse-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ELLIPTICAL_ROI_TOOL_USED',
  },
  {
    key: RectangleROITool.toolName,
    name: 'viewer.tools.rectangle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_RECTANGLE_ROI_TOOL_USED',
  },
  {
    key: PlanarFreehandROITool.toolName,
    name: 'viewer.tools.planarfreehandroi',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PLANARFREEHAND_ROI_TOOL_USED',
  },
  {
    key: ProbeTool.toolName,
    name: 'viewer.tools.probe',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PIXEL_PROBE_TOOL_USED',
  },
  {
    key: ArrowAnnotateTool.toolName,
    name: 'viewer.tools.annotation',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_TEXT_TOOL_USED',
  },
  {
    key: 'CINE',
    NotFor: ['CR', 'DX', 'US', 'SR', 'DOC'],
    name: 'viewer.tools.cine',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PLAY_CLIP_TOOL_USED',
  },
  {
    key: AngleTool.toolName,
    name: 'viewer.tools.angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ANGLE_TOOL_USED',
  },
  {
    key: CobbAngleTool.toolName,
    name: 'viewer.tools.cobb-angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_COBB_ANGLE_TOOL_USED',
  },
];

export const DEFAULT_TOOL = StackScrollTool.toolName;
export const XRAY_DEFAULT_TOOL = StackScrollTool.toolName;

export const LATERAL_VIEW_MODALITY_LIST = ['CT', 'MR'];
export const WINDOW_LEVEL_MODALITY_LIST = ['CT'];

export const SHOW_NOT_ORIGNAL_MODALITY_LIST = ['CT', 'MR'];
/**
 * Modalities whose studies can carry a fusable overlay, so the Fusion tool is
 * offered in the toolbar. NM belongs here alongside PT: the series picker
 * already lists NM under "PET Series" (see ColorLUTBody), so leaving it out
 * only hid the button on NM studies.
 */
export const FUSION_MODALITY_LIST = ['CT', 'MR', 'PT', 'NM'];
/**
 * Series whose instances are documents rather than image frames - an
 * Encapsulated PDF (DOC) or a Structured Report (SR). The viewport renders the
 * document itself instead of a cornerstone canvas, so tools that act on pixel
 * data have nothing to operate on when one of these is displayed.
 */
export const DOCUMENT_MODALITIES = ['DOC', 'SR'];
export const SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST = ['DX', 'CR', 'SC'];
export const REFLINES_SYNC_EXCLUDED_MODALITIES = ['CR', 'DX', 'US', 'SR', 'SC', 'DOC'];
export const SYNC_EXCLUDED_MODALITIES = ['CR', 'DX', 'US', 'SR', 'SC', 'DOC'];
export const SYNC_MODES = {
  DISABLED: 'disabled',
  MANUAL: 'manual',
  AUTOMATIC: 'automatic',
  DISTANCE: 'distance',
};
// Which viewports an action (WW/WL, zoom, pan) propagates to. SYNC_MODES scopes
// where you are in a stack; this scopes what you do to the image.
export const ACTION_SYNC_MODES = {
  DISABLED: 'disabled',
  ALL: 'all',
  SERIES: 'series',
  LINKED: 'linked',
};
export const CONSTRUCTABLE_MODALITIES = ['MR', 'CT', 'PT', 'NM'];
export const MAX_MPR_VOLUME_BYTES = 200 * 1024 * 1024;
export const WINDOW_LEVEL_PRESETS = [
  {
    key: 'Abdomen (1)',
    ww: 400,
    wc: 60,
    edge: false,
  },
  {
    key: 'Angio (2)',
    ww: 600,
    wc: 300,
    edge: false,
  },
  {
    key: 'Bone (3)',
    ww: 1500,
    wc: 300,
    edge: true,
  },
  {
    key: 'Brain (4)',
    ww: 80,
    wc: 40,
    edge: false,
  },
  {
    key: 'Chest (5)',
    ww: 400,
    wc: 40,
    edge: false,
  },
  {
    key: 'Lungs (6)',
    ww: 1500,
    wc: -400,
    edge: true,
  },
  {
    key: 'Cerebrum (7)',
    ww: 120,
    wc: 40,
    edge: false,
  },
  {
    key: 'Liver (8)',
    ww: 150,
    wc: 50,
    edge: false,
  },
  {
    key: 'Mediastinum (9)',
    ww: 300,
    wc: 50,
    edge: false,
  },
  {
    key: 'Pelvis',
    ww: 400,
    wc: 40,
    edge: false,
  },
  {
    key: 'Posterior Fossa',
    ww: 250,
    wc: 80,
    edge: false,
  },
  {
    key: 'Soft Tissue',
    ww: 400,
    wc: 40,
    edge: false,
  },
];

export const STUDY_DOWNLOAD_OPTIONS = [
  'Download Study',
  'Download PPT',
  'Download Images',
];

export const COLORS = {
  warning: '#F9B403',
};

export const CT_VALIDATION_MESSAGE = {
  _iMessageCtBrainSelectOptionAndWidthFromDimension:
    'Please select an option for the provided dimensions and also enter the width.',
  _iMessageCtBrainSelectOptionAndHeightFromDimension:
    'Please select an option for the provided dimensions and also enter the height.',
  _iMessageCtBrainErrorBleedRightDimensions:
    'Please enter the height and width for bleed right.',
  _iMessageCtBrainErrorBleedRightHeight:
    'Please enter the height for bleed right.',
  _iMessageCtBrainErrorBleedRightWidth:
    'Please enter the width for bleed right.',
  _iMessageCtBrainErrorBleedLeftDimensions:
    'Please enter the height and width for bleed left.',
  _iMessageCtBrainErrorBleedLeftHeight:
    'Please enter the height for bleed left.',
  _iMessageCtBrainErrorBleedLeftWidth: 'Please enter the width for bleed left.',
  _iMessageCtBrainErrorHemorrhagicRightDimensions:
    'Please enter the height and width for hemorrhagic contusion right.',
  _iMessageCtBrainErrorHemorrhagicRightHeight:
    'Please enter the height for hemorrhagic contusion right.',
  _iMessageCtBrainErrorHemorrhagicRightWidth:
    'Please enter the width for hemorrhagic contusion right.',
  _iMessageCtBrainErrorHemorrhagicLeftDimensions:
    'Please enter the height and width for hemorrhagic contusion left.',
  _iMessageCtBrainErrorHemorrhagicLeftHeight:
    'Please enter the height for hemorrhagic contusion left.',
  _iMessageCtBrainErrorHemorrhagicLeftWidth:
    'Please enter the width for hemorrhagic contusion left.',
  _iMessageCtBrainErrorEpiduralRightDimensions:
    'Please enter the height and width for epidural hematoma right.',
  _iMessageCtBrainErrorEpiduralRightHeight:
    'Please enter the height for epidural hematoma right.',
  _iMessageCtBrainErrorEpiduralRightWidth:
    'Please enter the width for epidural hematoma right.',
  _iMessageCtBrainErrorEpiduralLeftDimensions:
    'Please enter the height and width for epidural hematoma left.',
  _iMessageCtBrainErrorEpiduralLeftHeight:
    'Please enter the height for epidural hematoma left.',
  _iMessageCtBrainErrorEpiduralLeftWidth:
    'Please enter the width for epidural hematoma left.',
  _iMessageCtBrainErrorSubduralRightDimensions:
    'Please enter the height and width for subdural hematoma right.',
  _iMessageCtBrainErrorSubduralRightHeight:
    'Please enter the height for subdural hematoma right.',
  _iMessageCtBrainErrorSubduralRightWidth:
    'Please enter the width for subdural hematoma right.',
  _iMessageCtBrainErrorSubduralLeftDimensions:
    'Please enter the height and width for subdural hematoma left.',
  _iMessageCtBrainErrorSubduralLeftHeight:
    'Please enter the height for subdural hematoma left.',
  _iMessageCtBrainErrorSubduralLeftWidth:
    'Please enter the width for subdural hematoma left.',
  _iMessageCovidSrAdditionalFinding:
    'No focal or diffuse pathology in the visualized areas of the upper abdomen.',
};

export const COVID_SR_MESSAGE = {
  _iMessageCovidMild: 'Mild',
  _iMessageCovidModerate: 'Moderate',
  _iMessageCovidSevere: 'Severe',
  _iMessageCovidSectionAFinding:
    'Rest of the lung parenchyma is normal. No nodules or mass seen.',
  _iMessageCovidClinicalHistoryOtherError:
    'Please enter the clinical history comment.',
  _iMessageCovidOptionsNotSelectedError:
    'Please select at least one zone for the selection in section A.',
  _iMessageCovidReverseHaloSignError:
    'Please select present or absent option for reverse halo sign.',
  _iMessageCovidSectionError: 'Please select either section A or section B.',
  _iMessageCovidCoradsError: 'Please select the applicable corads option.',
};

export const VALIDATE_SPINE = {
  _imessageSelectEitherScolosisLumbarOrScolasisThoracolumbar:
    'Select either Scolosis Lumbar or Scolasis Thoracolumbar',
  _imessageSelectEitherAbnormalSclerosedOrAbnormalErosion:
    'Select either Abnormal Sclerosed or Abnormal Erosion',
  _imessageLumbarSpineFractureShouldBeWithSpineOrLumbarWithObliquesOrLumbarWithFlexionAndExtension:
    'Lumbar Spine Fracture should be used with Spine or Lumbar With Obliques or Lumbar With Flexion and Extension',
  _imessageSelectApplicableSuboptionFromLysisLevel:
    'Select applicable suboption from Lysis->Level',
  _imessageListhesisCanNotBeAbsent: 'Listhesis can not be absent',
  _imessageAbsentOptionCannotBeUsedWithLysisListhesisMildModerateSevere:
    'Absent option cannot be used with Lysis->Listhesis Mild/Moderate/Severe',
  _imessageSelectOnlyOneOptionFromLysisListhesisMildModerateSevere:
    'Select only one option from Lysis->Listhesis Mild/Moderate/Severe',
  _iPleaseSelect: 'Please select',
  _iOnlyOnceFrom: 'only once from',
  _iOr: 'or',
  _iselectOneTechnique: 'Select one technique at a time',
};

export const GENERAL_FRACTURE_VALIDATION = {
  _iselectOptionOrRemoveAnnotation:
    'Please select option/suboption or remove General Fracture annotation',
  _ienterPlasterLocation: 'Please enter Plaster-Location details',
  _iselectOneFromPlaster: 'Please select one value from Plaster-Area',
  _iselectOneFromCastOrSlab:
    'Please select one option from Plaster-cast/slab or nil',
  _iUnselectDisplacemetNil: 'Please unselect General Fracture-Displacement-Nil',
  _iselectOneFromAvulusionFracture:
    'Please select only one option small or large from  General Fracture-Displacement-Avulusion Fracture',
  _iselectEitherUndisplacedOrMinimalOrSignificant:
    'lease select either Undisplaced or Minimally displaced or Significantly displaced from  General Fracture-Displacement-Avulusion Fracture',
  _iUnselectTypeNil: 'Please unselect General Fracture-Type-Nil',
  _iUnselectFragmentNil: 'Please unselect General Fracture-Fragments-Nil',
  _iUnselectFragmentAligned:
    'Please unselect General Fracture-Fragments-Aligned',
  _iselectWithOrWithoutIAE:
    'Please select with or without intra articular extension from General Fracture-Fragments',
  _iUnselectAbsentFromCallus:
    'Please unselect Absent from General Fracture-Callus',
  _iUnselectNilAssociatedFindings:
    'Please unselect Nil option from General Fracture-Associated Findings',
  _iUnselectNilImplants:
    'Please unselect Nil option from General Fracture-Implants',
  _iUnselectNilSoftTissue:
    'Please unselect Nil option from General Fracture-Soft Tissue',
};

export const COVID_SUSPECT_VALIDATION = {
  _iOneCovidTtemplate: 'Please select one COVID template.',
  _iOneOptionCVCX1: 'Please select one option from CVCX1.',
  _iOneSuboptionCVCX2:
    'Please select one suboption from Severity and Location from CVCX2',
  _iOneOptionCVCX3Pneumothorax:
    'Please select one option from CVCX3->Mild/Moderate/Severe Pneumothorax.',
  _iOneOptionCVCX3PleuralEffusion:
    'Please select one option from CVCX3->Mild/Moderate/Severe Pleural Effusion',
};

export const MRI_SPINE_VALIDATION_MSG = {
  _iMessageOtherClinicalProfileError:
    'Please enter the other clinical profile details.',
  _iMessageOtherSuggestedImpressionError:
    'Please enter the other suggested impression.',
};

export const RSNA_VALIDATION_MSG = {
  _iMessageRsnaClinicalHistoryError:
    'Please enter the comment for clinical history.',
  _iMessageRsnaLimitationError: 'Please enter the comment for limitation.',
  _iMessageRsnaFindingSelectionError:
    'No findings are selected. Select findings to proceed.',
};

export const REPORT_TITLE = {
  TUBERCULOSIS: 'TUBERCULOSIS',
  HRCT_CHEST_ILD: 'HRCT CHEST ILD',
  HRCT_CHEST_COVID: 'HRCT CHEST TO EXCLUDE/DIAGNOSE COVID-19',
  CT_BRAIN: 'CT BRAIN SR',
  HRCT_CHEST_COVID_SR: 'HRCT CHEST COVID SR',
  MRI_SPINE_SR: 'MRI SPINE SR',
};


export const THUMBNAIL_FETCH_SIZE = isMobile ? 1 : 50;
export const THUMBNAIL_BATCH_SIZE = 5;

// --- Background series-preload tuning (startPrefetching in ThumbnailState) ---
// The preload used to sleep 1200ms before EVERY series and load only 5 images
// per await-cycle, serially — so a 20-series study spent ~24s just sleeping
// while the request pools (50 load / 100 retrieval per lane, see
// CornerstoneService.applyPoolCaps) sat almost idle. These two knobs open it up.
//
// PREFETCH_SERIES_DELAY_MS: yield between series so the active viewport's own
//   load isn't starved and the pool isn't stampeded the instant a study opens.
//   Kept small (was 1200) — desktop only; mobile stays gentler.
// PREFETCH_IMAGE_CONCURRENCY: how many loadAndCacheImage calls prefetchData
//   keeps IN FLIGHT at once. This is a sliding window, NOT a batch barrier: the
//   moment one image finishes (network + web-worker decode) the next is fired,
//   so the request lanes and worker pool never sit idle. The old code awaited a
//   whole batch of N before firing the next N, which stalled the network for the
//   full decode time of the slowest image in the batch (visible as multi-second
//   gaps between bursts even on a single-series study). Sized around the decode
//   ceiling (maxWebWorkers = min(hardwareConcurrency, 7)) with headroom for the
//   network round-trip; well under the pool caps (50/100).
//
// PREFETCH_IMAGE_CONCURRENCY_WHILE_INTERACTING: the floor of that window. These
//   lanes never stop; the lanes above it pause while the user is moving the
//   pointer, clicking, scrolling or typing, and resume once they stop. Every
//   decoded image is still taken in on the main thread, so fewer arriving while
//   the user acts keeps menus, tooltips and hover responsive during preload
//   without ever stalling it. (Was 16 lanes with no floor: decoded images then
//   arrived in bursts larger than the 7 decode workers could smooth out.)
//
// If net::ERR_INSUFFICIENT_RESOURCES reappears, raise the delay / lower the
// concurrency — do NOT lower the pool caps (see the comment in CornerstoneService).
export const PREFETCH_SERIES_DELAY_MS = isMobile ? 400 : 150;
//
// Desktop uses 12 lanes on a capable machine (8+ CPU cores and, where the
// browser reports it, 8 GB+ RAM) and 8 otherwise, since every decoded image is
// held in RAM. navigator.deviceMemory is Chromium-only and rounded (max 8);
// when it is missing only the core count decides. The floor is about three
// quarters of the window.
const prefetchConcurrencyForMachine = () => {
  if (isMobile) return 5;
  const cores = (typeof navigator !== "undefined" && navigator.hardwareConcurrency) || 0;
  const memoryGb = typeof navigator !== "undefined" ? navigator.deviceMemory : undefined;
  const capable = cores >= 8 && (memoryGb === undefined || memoryGb >= 8);
  return capable ? 12 : 8;
};
export const PREFETCH_IMAGE_CONCURRENCY = prefetchConcurrencyForMachine();
export const PREFETCH_IMAGE_CONCURRENCY_WHILE_INTERACTING = isMobile
  ? 3
  : Math.ceil(PREFETCH_IMAGE_CONCURRENCY * 0.75);

// --- Multi-frame cine prefetch throttle (enqueueFramePrefetch) ---------------
// enqueueFramePrefetch -> loadAndCacheImage does NOT go through Cornerstone's
// imageLoadPoolManager (that pool only gates the viewport stack path). It calls
// the wadors loader directly, which does xhr.send() immediately. So a 776-frame
// cine used to fire all 776 XHRs in a single tick — the browser's per-origin
// socket limit was the only thing pacing them, flooding the Network tab and
// risking net::ERR_INSUFFICIENT_RESOURCES. This cap is a client-side semaphore:
// at most this many frame prefetches are in flight at once; each completion
// releases a slot for the next (highest-priority-first). Raise cautiously.
export const MULTIFRAME_PREFETCH_CONCURRENCY = isMobile ? 10 : 50;

export const VIEWER_PROGRESS_STATE = {
  API: 10,
  TRANSFORM: 10,
  THUMBNAIL: 70,
  VIEWPORT: 100,
};

export const TOAST_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  BATCHASSIGN: 'batchAssign',
  SUSPECT: 'suspect',
  WARNING: 'warning',
};

export const STACK_SCROLL_DROPDOWN_ELEMENTS = [
  { key: 'Go to Previous Series' },
  { key: 'Go to Next Series' },
];

export const MOBILE_TOOLS = [
  {
    key: StackScrollTool.toolName,
    NotFor: [],
    name: 'viewer.tools.stack-scroll',
  },
  {
    key: WindowLevelTool.toolName,
    NotFor: [],
    name: 'viewer.tools.window',
  },
  {
    key: ZoomTool.toolName,
    NotFor: [],
    name: 'viewer.tools.zoom',
  },
  {
    key: PanTool.toolName,
    NotFor: [],
    name: 'viewer.tools.pan',
  },
  {
    key: LengthTool.toolName,
    NotFor: [],
    name: 'viewer.tools.length',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.ellipse',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
  },
  {
    key: 'Reset',
    NotFor: [],
    name: 'viewer.tools.reset',
  },
  {
    key: 'Invert',
    NotFor: [],
    name: 'viewer.tools.invert',
  },
  {
    key: 'RotateRight',
    NotFor: [],
    name: 'viewer.tools.rotate-right',
  },
  {
    key: 'RotateLeft',
    NotFor: [],
    name: 'viewer.tools.rotate-left',
  },
  {
    key: 'FlipVertical',
    NotFor: [],
    name: 'viewer.tools.flipV',
  },
  {
    key: 'FlipHorizontal',
    NotFor: [],
    name: 'viewer.tools.flipH',
  },
  {
    key: ProbeTool.toolName,
    NotFor: [],
    name: 'viewer.tools.probe',
  },
  {
    key: ArrowAnnotateTool.toolName,
    NotFor: [],
    name: 'viewer.tools.annotation',
  },
  {
    key: 'CINE',
    NotFor: ['CR', 'DX', 'US', 'SR', 'DOC'],
    name: 'viewer.tools.cine',
  },
];

// Measurement / ROI tools surfaced in the mobile "Measure" dropdown.
// Mirrors the measurement set available in the desktop basic viewer.
export const MOBILE_MEASURE_TOOLS = [
  {
    key: LengthTool.toolName,
    NotFor: [],
    name: 'viewer.tools.length',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
  },
  {
    key: AngleTool.toolName,
    NotFor: [],
    name: 'viewer.tools.angle',
  },
  {
    key: CobbAngleTool.toolName,
    NotFor: [],
    name: 'viewer.tools.cobb-angle',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.ellipse',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
  },
  {
    key: CircleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.circleroi',
  },
  {
    key: PlanarFreehandROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.planarfreehandroi',
  },
  {
    key: 'CalibrationLine',
    NotFor: [],
    name: 'viewer.tools.calibration-line',
  },
];
// Desktop "Measure" dropdown tools
export const MEASURE_TOOLS = [
  ...MOBILE_MEASURE_TOOLS,
  {
    key: ProbeTool.toolName,
    NotFor: [],
    name: 'viewer.tools.probe',
  },
];

// Tools shown in the mobile bottom-toolbar "More" grid (icon + name tiles).
// Rendered via the shared <Tool> component so activation logic is reused.
export const MOBILE_MORE_TOOLS = [
  { key: 'Reset', NotFor: [], name: 'viewer.tools.reset' },
  { key: PanTool.toolName, NotFor: [], name: 'viewer.tools.pan' },
  { key: ZoomTool.toolName, NotFor: [], name: 'viewer.tools.zoom' },
  { key: StackScrollTool.toolName, NotFor: [], name: 'viewer.tools.stack-scroll' },
  { key: MagnifyTool.toolName, NotFor: [], name: 'viewer.tools.magnify' },
  { key: ProbeTool.toolName, NotFor: [], name: 'viewer.tools.probe' },
  { key: ArrowAnnotateTool.toolName, NotFor: [], name: 'viewer.tools.annotation' },
  { key: 'Invert', NotFor: [], name: 'viewer.tools.invert' },
  { key: 'CINE', NotFor: ['CR', 'DX', 'US', 'SR', 'DOC'], name: 'viewer.tools.cine' },
  { key: 'Synchronize', NotFor: ['CR', 'DX', 'US', 'SR', 'SC', 'DOC'], name: 'viewer.tools.synchronize' },
  // Reference Lines in the mobile More grid — same key / NotFor / event as the
  // desktop TOOLS entry, so it stays hidden for X-ray (CR/DX) etc., matching desktop.
  {
    key: ReferenceLinesTool.toolName,
    NotFor: ['CR', 'DX', 'US', 'SR', 'SC', 'DOC'],
    name: 'viewer.tools.reference',
    isEvent: true,
    eventName: 'EVENT_BASIC_REFERENCE_LINES_TOOL_USED',
  },
];

export const widthOfColumns = (role, isLandscape = false) => {
  if (role == USERTYPES.ADMIN) {
    return {
      selectColumn: '4%',
      patientColumn: '11%',
      studyColumn: '14%',
      clientColumn: isLandscape ? '11%' : '14%',
      radiologistColumn: isLandscape ? '14%' : '16%',
      reportColumn: isLandscape ? '15%' : '10%',
      actionColumn: '10%',
      triageColumn: '10%',
    };
  }
  if (role == USERTYPES.FIRMADMIN || role == USERTYPES.SUPERVISOR) {
    return {
      selectColumn: '4%',
      patientColumn: '11%',
      studyColumn: '14%',
      clientColumn: isLandscape ? '11%' : '13%',
      qcColumn: '13%',
      radiologistColumn: isLandscape ? '12%' : '16%',
      reportColumn: isLandscape ? '17%' : '10%',
      actionColumn: '10%',
      triageColumn: '10%',
      requestDetailsColumn: '20%',
      // Widths for Access Request tabs (pending / approved / rejected)
      // select(4%) + patient(15%) + study(15%) + client(28%) + report(18%) + requestDetails(20%) = 100%
      archived: {
        selectColumn: '4%',
        patientColumn: '12%',
        studyColumn: '15%',
        clientColumn: '25%',
        reportColumn: '16%',
        requestDetailsColumn: '14%',
      },
    };
  } else if (role == USERTYPES.RADIOLOGIST) {
    return {
      selectColumn: '3%',
      patientColumn: '15%',
      studyColumn: '15%',
      radiologistColumn: isLandscape ? '13%' : '15%',
      reportColumn: isLandscape ? '20%' : '15%',
      actionColumn: '10%',
      triageColumn: '15%',
    };
  } else {
    return {
      selectColumn: '3%',
      patientColumn: '13%',
      studyColumn: '15%',
      clientColumn: isLandscape ? '8%' : '11%',
      radiologistColumn: isLandscape ? '14%' : '16%',
      reportColumn: isLandscape ? '15%' : '10%',
      actionColumn: '6%',
      triageColumn: '10%',
    };
  }
};

export const showPathologyForModalities = ['DX', 'CR', 'RG', 'SC'];
export const ECG = 'ECG';
export const US = 'US';

export const modalityRowBadgeColor = (modality) => {
  switch (modality) {
    case 'CT':
      return { background: '#E37475', color: '#FFFFFF' };
    case 'DX':
      return { background: '#6DA370', color: '#FFFFFF' };
    case 'CR':
      return { background: '#5B9BCD', color: '#FFFFFF' };
    case 'MRI':
      return { background: '#B99A40', color: '#FFFFFF' };
    case 'MR':
      return { background: '#5627A4', color: '#FFFFFF' };
    case 'US':
      return { background: '#C4664C', color: '#FFFFFF' };
    case 'NM':
      return { background: '#73A53A', color: '#FFFFFF' };
    case 'MG':
      return { background: '#BC8E44', color: '#FFFFFF' };
    case 'OT':
      return { background: '#BF4E84', color: '#FFFFFF' };
    case 'PT':
      return { background: '#ABB44D', color: '#FFFFFF' };
    case 'SR':
      return { background: '#B18A4E', color: '#FFFFFF' };
    case 'DOC':
      return { background: '#7A6FA8', color: '#FFFFFF' };
    default:
      return { background: '#A64B4B', color: '#FFFFFF' };
  }
};

export const ORDER_ID_COLORS = [
  { background: '#E37475', color: '#FFFFFF' },
  { background: '#6DA370', color: '#FFFFFF' }, 
  { background: '#5B9BCD', color: '#FFFFFF' }, 
  { background: '#B99A40', color: '#FFFFFF' }, 
  { background: '#5627A4', color: '#FFFFFF' }, 
  { background: '#C4664C', color: '#FFFFFF' }, 
  { background: '#73A53A', color: '#FFFFFF' }, 
  { background: '#BC8E44', color: '#FFFFFF' }, 
  { background: '#BF4E84', color: '#FFFFFF' }, 
  { background: '#ABB44D', color: '#FFFFFF' }, 
  { background: '#B18A4E', color: '#FFFFFF' }, 
  { background: '#A64B4B', color: '#FFFFFF' }, 
  { background: '#E85D04', color: '#FFFFFF' }, 
  { background: '#2EC4B6', color: '#FFFFFF' }, 
  { background: '#4361EE', color: '#FFFFFF' }, 
  { background: '#3A86FF', color: '#FFFFFF' }, 
  { background: '#8338EC', color: '#FFFFFF' }, 
  { background: '#FF006E', color: '#FFFFFF' }, 
  { background: '#06D6A0', color: '#FFFFFF' }, 
  { background: '#FFD166', color: '#000000' },
];

export const REPORT_DONE_STATUS = {
  UNREPORTED: 0,
  SAVED: 1,
  /** Rollout alias: existing Saved (1) is treated as Preliminary. */
  PRELIMINARY: 1,
  REPORTED: 2,
  QCREVIEW: 3,
  QCFIX: 4,
  QCVERIFY: 5,
  /** Draft / Saved tab (study list). */
  DRAFT: 6,
  MARK_AS_SUSPECTED: 7,
  PRELIMINARY_QC_REVIEW: 7,
  PRELIMINARY_QC_FIX: 8,
  PRELIMINARY_QC_VERIFY: 9,
};

export const TAB_NAME = {
  UNREPORTED: 'unreported',
  SAVED: 'saved',
  DRAFT: 'draft',
  REPORTED: 'reported',
  CLOSED: 'closed',
  QCREVIEW: 'qcreview',
  QCREVIEWASSIGNED: 'qcreviewAssigned',
  QCFIX: 'qcfix',
  QCVERIFY: 'qcverify',
  RETURNED: 'returned',
  CRITICAL: 'critical',
  LIBRARY: 'library',
  NORMAL: 'normal',
  NORMALWITHFB: 'normalwithfb',
  ABNORMAL: 'abnormal',
  PEERREVIEW: 'peerReview',
  REVIEWASSIGNED: 'reviewAssigned',
  REVIEWCOMPLETE: 'reviewComplete',
  EVALUATIONASSIGNED: 'evaluationAssigned',
  EVALUATIONCOMPLETE: 'evaluationComplete',
  PENDING:'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVIEWPENDING: 'reviewPending',
  ALL: 'all',
};

export const STUDY_SEARCH_RESULTS_ID = 'study_search_results';

export const DEFAULT_SORT_COLUMNS = new Set([
  "assignment_created_date",
  "report_submitted_date",
  "review_assigned_date",
  "review_completed_date",
  "evaluation_assigned_date",
  "evaluation_completion_date",
  "requested_date",
  "approved_date",
  "requested_date2",
  "emergency_status",
  "assignment_created_date"
]);

export const FILTER_TYPE = {
  ModalityList: 'modalityList',
  ClientFirmList: 'clientFirmList',
  AnnotationList: 'annotationList',
  ClassificationList:'classificationList',
  PriorityList: 'priorityList',
  RadiologistList: 'radiologistList',
  AssignmentDateRange: "assignmentDateRange",
  SubModalityList: 'subModalityList',
};

export const CXR_TABS = {
  unreported: 'Unreported',
  normal: 'CXR: No Suspicions',
  normalWithFB: 'CXR: FO Only',
  abnormal: 'CXR: With Suspicions',
  unassigned: 'Unassigned Studies', 
};

export const PEER_REVIEW_TABS = {
  reviewAssigned: 'Review Assigned',
  reviewComplete: 'Review Complete',
  evaluationAssigned: 'Evaluation Assigned',
  evaluationComplete: 'Evaluation Complete',
};

export const QC_REVIEW_TABS = {
  qcreviewAssigned: 'Assigned to Me',
  qcreview: 'All',
};

export const QC_REVIEW_TABS_NAME = ['qcreviewAssigned', 'qcreview'];

export const CXR_TABS_NAME = [
  'unreported',
  'normal',
  'normalwithfb',
  'abnormal',
  'unassigned',
];

export const PEER_REVIEW_TABS_NAME = [
  'reviewAssigned',
  'reviewComplete',
  'evaluationAssigned',
  'evaluationComplete',
];

export const ARCHIVED_STUDY_TABS = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};

export const ARCHIVED_STUDY_TABS_NAME = [
  'pending',
  'approved',
  'rejected',
];

export const SAVED_TABS = {
  saved: 'All Studies',
  reviewPending: 'Review Pending',
   unassigned: 'Unassigned Studies',
   readyForReview: 'Ready for Review',
};

export const SAVED_TABS_NAME = [
  'saved',
  'reviewPending',
  'unassigned',
  'readyForReview',
];

export const REPORTED_TABS = {
  reported: 'All Studies',
  positive: 'Positive',
  negative: 'Negative',
  resubmission: 'Resubmitted',
};

export const REPORTED_TABS_NAME = [
  'reported',
  'positive',
  'negative',
  'resubmission',
];

export const CXR_SUBTABS_ID = ['study_1', 'study_11', 'study_12', 'study_13'];
export const UNREPORTED_SUBTABS_ID = [...CXR_SUBTABS_ID, 'study_27'];
export const QC_REVIEW_SUBTABS_ID = ['study_5', 'study_24'];
export const PEER_REVIEW_SUBTABS_ID = ['study_14', 'study_15', 'study_16', 'study_17'];
export const ARCHIVED_ACCESS_SUBTABS_ID = ['study_18', 'study_19', 'study_20'];
export const SAVED_SUBTABS_ID = ['study_2', 'study_21','study_28', 'study_29'];
export const REPORTED_SUBTABS_ID = ['study_3', 'study_22', 'study_23', 'study_25'];

export const CXR_TABS_ALLOWED_ROLES = [
  USERTYPES.ADMIN,
  USERTYPES.FIRMADMIN,
  USERTYPES.SUPERVISOR,
  USERTYPES.RADIOLOGIST,
];

export const PEER_REVIEW_TABS_ALLOWED_ROLES = [
  USERTYPES.ADMIN,
  USERTYPES.FIRMADMIN,
  USERTYPES.SUPERVISOR,
  USERTYPES.RADIOLOGIST,
];

export const QC_REVIEW_TABS_ALLOWED_ROLES = [
  USERTYPES.SUPERVISOR,
];

export const ARCHIVED_STUDY_ACCESS_TABS_ALLOWED_ROLES = [
  USERTYPES.FIRMADMIN,
];

export const SAVED_TABS_ALLOWED_ROLES = [
  USERTYPES.RADIOLOGIST,
  USERTYPES.FIRMADMIN,
  USERTYPES.SUPERVISOR,
];

export const VDCLIMS = {
  DUE: 'DUE',
  PAID: 'PAID',
  ERROR: 'ERROR',
  PaymentStatusCodes: {
    DUE: 0,
    PAID: 1,
    ERROR: 2,
  },
  paymentStatusCodesToString: (code) => {
    if (code == 0) return VDCLIMS.DUE;
    else if (code == 1) return VDCLIMS.PAID;
    return VDCLIMS.ERROR;
  },
  PAYMENT_STATUS_IS_NOT_CLEAR: 'Payment status is not clear',
  PAYMENT_MESSAGE_FOR_ERROR:
    'Unable to perform action - Reason:  Error fetching payment data.',
  PAYMENT_MESSAGE_FOR_DUE:
    'Unable to perform action - Reason: Payment for this study is not complete.',
};

export const BADGE_INFO_OBJ = {
  MORE_THAN_2_HR: {
    COLOR_NAME: 'morethan2hr',
    BACKGROUND: 'rgba(243, 113, 113, 0.45)',
    TEXT_COLOR: 'rgb(233 19 19)',
  },
  SAVED: {
    BACKGROUND: '#CEF29F',
    TEXT_COLOR: '#004F32',
  },
  LESS_THAN_1_HR: {
    COLOR_NAME: 'lessthan1hr',
    BACKGROUND: 'rgba(217, 82, 234, 0.22)',
    TEXT_COLOR: 'rgb(180 40 198)',
  },
  LESS_THAN_2_HR: {
    COLOR_NAME: 'lessthan2hr',
    BACKGROUND: '#ffa500',
    TEXT_COLOR: '#7c5b1e',
  },
  MORE_THAN_24_HR: {
    COLOR_NAME: 'morethan24hr',
    BACKGROUND: 'rgb(193 46 13)',
    TEXT_COLOR: 'white',
  },
  QC_REVIEW_PENDING: {
    BACKGROUND: 'rgb(126, 85, 239)',
    TEXT_COLOR: 'white',
  },
  QC_FIX_PENDING: {
    BACKGROUND: 'rgb(176, 167, 43)',
    TEXT_COLOR: 'white',
  },
  QC_VERIFICATION_PENDING: {
    BACKGROUND: 'rgb(63, 120, 72)',
    TEXT_COLOR: 'white',
  },
  REPORTED: {
    BACKGROUND: 'rgba(84, 136, 202, 0.51)',
    TEXT_COLOR: 'rgb(0 61 139)',
  },
  RESUBMITTED: {
    BACKGROUND: '#CEF29F',
    TEXT_COLOR: '#033701',
  },
  TAT_LESS_THAN_1_HR: {
    COLOR_NAME: 'TATlessthan1hour',
    BACKGROUND: 'rgba(126, 248, 6, 0.21)',
    TEXT_COLOR: 'white',
  },
  TAT_MORE_THAN_12_HR: {
    COLOR_NAME: 'TATmorethan12hours',
    BACKGROUND: 'rgba(209, 21, 21, 0.24)',
    TEXT_COLOR: 'white',
  },
  TAT_BETWEEN_1_TO_2_HR: {
    COLOR_NAME: 'TATbetween1to2hours',
    BACKGROUND: 'rgba(255, 235, 59, 0.51)',
    TEXT_COLOR: 'white',
  },
  TAT_BETWEEN_2_TO_3_HR: {
    COLOR_NAME: 'TATbewteen2to3hours',
    BACKGROUND: 'rgba(227, 140, 51, 0.43)',
    TEXT_COLOR: 'white',
  },
  TAT_BETWEEN_3_TO_12_HR: {
    COLOR_NAME: 'TATbetween3to12hours',
    BACKGROUND: 'rgba(208, 13, 241, 0.23)',
    TEXT_COLOR: 'white',
  },
};

export const BADGE_COLOR_NAME = {
  LESS_THAN_1_HR: 'lessthan1hr',
};

export const BORDER = {
  TAB: '1px solid #585858',
};

export const SELECTED_TAB_KEY = {
  TROUBLESHOOTING: 'trouble_',
  REPORTTEMPLATE: 'report_',
  UPLOADSTUDY: 'uploadStudy_',
  PACSQUEUE:'pacQueue_',
  ANALYTICS: 'analytics_',
};

export const MAX_HISTORY_UPLOAD_BASENAME_LENGTH = 100;
export const CUSTOM_STYLES = {
  ACTIVE_TAB: '1px solid #585858',
  STUDYLIST_TD_TOP_MARGIN: '15px',
  MODAL_BORDER: '1px solid #585858',
};

export const MODAL_TYPE = {
  AVAILABLE_NOW: 'AVAILABLE_NOW',
  ALERT_MODAL: 'ALERT_MODAL',
  THEME_PREFERENCE: 'THEME_PREFERENCE',
  TOUR: 'TOUR',
  MULTI_SESSION_WARNING_MODAL: "MULTI_SESSION_WARNING_MODAL",
};

export const REPORT_SUBMIT_SOURCE = {
  STUDYLIST: '/new/studylist',
  ADVANCE_VIEWER: '/nonXrayAdvanceViewer',
};

export const PATHOLOGY_STATUS = {
  VERIFIED: 'verified',
  ADDED: 'added',
  REJECTED: 'rejected',
};

export const HEADER_SEPERATOR = '2px solid rgb(93 93 93 / 46%)';

export const SHARED_VIEWER = {
  ADVANCE: 0,
  BASIC: 1,
};
export const LIGHT_THEME_ICON_COLOR = '#333333';

export const SPECIALCHAR_UNICODE_REGEX =
  /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F\u200C-\u200F\u2028\u2029\u00AD]/g;

export const THEME_NAME = {
  LIGHT: 'light',
};

export const NO_OF_IMAGES_STATUS = {
  MORE_THAN_ZERO_NO_OF_IMAGES: 1,
  ZERO_NO_OF_IMAGES: 0,
};

export const MAX_FILTER_BADGES_LENGTH =
  getEnv("REACT_APP_VDC_PLATFORM") == 'true' ||
  getEnv("REACT_APP_VDC_PLATFORM") == true
    ? 4  // Small screens: 4 badges visible
    : 3;

export const MAX_FILTER_BADGES_LENGTH_LARGE_SCREEN =
  getEnv("REACT_APP_VDC_PLATFORM") == 'true' ||
  getEnv("REACT_APP_VDC_PLATFORM") == true
    ? 2  // Large screens (>= 1200px): 2 badges visible
    : 1;
export const RESPONSIVE_BADGE_BREAKPOINT = 1200;

export const REINFERECE_ALLOWED_MODALITY = ['DX', 'CR', 'RG', 'SC'];

export const PLATFORM = {
  FAHES: 'fahes'
  // Add more if needed
};

export const roleAccess = {
  FIRM_ADMIN: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ERRORSTUDY,
    AuthRoutes.ANALYTICS,
    AuthRoutes.ISSUESANDTROUBLESHOOTING,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.RADIOLOGISTLIST,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.MYVIEWUSER,
    AuthRoutes.EDITADMINUSER,
    AuthRoutes.PROVIDERVIEW,
    AuthRoutes.REPORT_TEMPLATE,
    AuthRoutes.REPORTTEMPLATES,
    AuthRoutes.SUPERVISORLIST,
    AuthRoutes.MYADDSUPERVISOR,
    AuthRoutes.MYADDADMINUSER,
    AuthRoutes.MYADDFIRMDOCTOR,
    AuthRoutes.MYADDFIRMADMINUSER,
    AuthRoutes.MYADDFIRMTECHNICIAN,
    AuthRoutes.FIRMTECHNICIANLIST,
    AuthRoutes.FIRMDOCTORLIST,
    AuthRoutes.FIRMADMINUSERLIST,
    AuthRoutes.EDITHEADERTEMPLATE,
    AuthRoutes.ADDHOSPITAL,
    AuthRoutes.ADDTELERADIOLOGYCENTRE,
    AuthRoutes.ADDIMAGINGCENTRE,
    AuthRoutes.EDITHOSPITAL,
    AuthRoutes.MYADDRADIOLOGIST,
    AuthRoutes.ADDREPORTTEMPLATE,
    AuthRoutes.EDITREPORTTEMPLATE,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.TYPISTUSERLIST,
    AuthRoutes.ADDTYPIST,
    AuthRoutes.BILLING_DATA_DOWNLOAD_FORM,
    AuthRoutes.PACSQUEUELIST,
    AuthRoutes.AIREQUESTLIST,
    AuthRoutes.GATEWAY_DASHBOARD,
    AuthRoutes.FIRM2FIRM_DASHBOARD,
    AuthRoutes.AGENTIC_TEMPLATE,
    AuthRoutes.ADD_AGENTIC_TEMPLATE,
    AuthRoutes.EDIT_AGENTIC_TEMPLATE,
    AuthRoutes.REFRESHAGENTLIST,
    AuthRoutes.AI_NODE_CONFIG,
    AuthRoutes.EXTERNAL_FIRM_CONFIG,
    AuthRoutes.USER_DATA_DUMP,
    AuthRoutes.DOWNLOADAGENTICEVENT,
  ],
  RADIOLOGIST: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.REPORT_TEMPLATE,
    AuthRoutes.REPORTTEMPLATES,
    AuthRoutes.ADDREPORTTEMPLATE,
    AuthRoutes.EDITREPORTTEMPLATE,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.PACSQUEUELIST,
    AuthRoutes.HANGINGPROTOCOLLIST,
    AuthRoutes.ADDHANGINGPROTOCOL,
    AuthRoutes.EDITHANGINGPROTOCOL,
    AuthRoutes.VIEWHANGINGPROTOCOL,
    AuthRoutes.HANGINGPROTOCOLV2,
    AuthRoutes.HPV2_ADDGROUP,
    AuthRoutes.HPV2_EDITGROUP,
    AuthRoutes.HPV2_VIEWGROUP,
    AuthRoutes.HPV2_ADDPROTOCOL,
    AuthRoutes.HPV2_EDITPROTOCOL,
    AuthRoutes.HPV2_VIEWPROTOCOL,
    AuthRoutes.MY_STYLES,
    AuthRoutes.ADD_STYLE,
    AuthRoutes.EDIT_STYLE,
    AuthRoutes.BLITZREPORTING,
  ],
  SUPERVISOR: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.REPORTTEMPLATES,
    AuthRoutes.ADDREPORTTEMPLATE,
    AuthRoutes.EDITREPORTTEMPLATE,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.PACSQUEUELIST,
    AuthRoutes.AIREQUESTLIST,
    AuthRoutes.GATEWAY_DASHBOARD,
    AuthRoutes.FIRM2FIRM_DASHBOARD,
    AuthRoutes.BLITZREPORTING,
    AuthRoutes.EXTERNAL_FIRM_CONFIG,
  ],
  HOSPITAL_DOCTOR: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.EDITHEADERTEMPLATE,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.FIRM2FIRM_DASHBOARD,
  ],
  HOSPITAL_USER: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.EDITHEADERTEMPLATE,
    AuthRoutes.EDITHOSPITAL,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.FIRM2FIRM_DASHBOARD,
  ],
};

export const commonAllowedRolesAccess = [
  AuthRoutes.ACCOUNTANDSETTINGS,
  AuthRoutes.ABOUT,
  AuthRoutes.PRIVACY_POLICY,
  AuthRoutes.SHOW_SHARED_REPORT,
  AuthRoutes.SHAREDVIEWER,
  AuthRoutes.FORCECHANGEPWD,
  AuthRoutes.CHANGEPWD,
  AuthRoutes.MOBILEMORE,
];

export const TABS = {
  ACTIVE_BACKGROUND: "#0078D4",
  LIGHT_GLOBAL_GRAY: "#EEE"
}

export const HP_META_TAGS = {
  MODALITY: "0008,0060",
  BODY_PART_EXAMINED: "0018,0015",
  STUDY_DESCRIPTION: "0008,1030",
  SERIES_DESCRIPTION: "0008,103E",
  SERIES_NUMBER: "0020,0011",
  SOP_CLASS_UID: "0008,0016",
  INSTANCE_NUMBER: "0020,0013",
  TRANSFER_SYNTAX_UID: "0002,0010",
  SAMPLES_PER_PIXEL: "0028,0002",
  IMAGE_TYPE: "0008,0008", 
  IMAGE_LATERALITY: "0020,0062", 
  PATIENT_ORIENTATION: "0020,0020",
  VIEW_POSITION: "0018,5101", 
};

export const HP_OPERANDS = {
  EQUALS: "equals",
  NOT_EQUALS: "not_equals",
  CONTAINS: "contains",
  LESS_THAN: "less_than",
  GREATER_THAN: "greater_than",
  LESS_THAN_EQUALS: "less_than_equals",
  GREATER_THAN_EQUALS: "greater_than_equals",
};

export const HP_VIEWPORT_FLIP = {
  ENABLE: "enable",
  DISABLE: "disable",
};

export const HP_VIEWPORT_ALIGNMENT = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center",
};

export const MODEL_OPTIONS = [
    { key: "deeptek", text: "DeepTek" },
    { key: "lunit", text: "Lunit" },
    { key: "iScreen", text: "iScreen" },
  ];

export const storageType = Object.freeze({
  HOT_STORAGE: 1,
  COLD_STORAGE: 2,
  TEMP_STORAGE: 3,
  DELETED_IMAGES_FROM_STORAGE: 4,
  DELETED_STUDY_REPORT_FROM_STORAGE: 5
});

export const RESTRICTED_STORAGE_TYPES = [
  storageType.DELETED_IMAGES_FROM_STORAGE,
  storageType.DELETED_STUDY_REPORT_FROM_STORAGE
];
